import { createGlobalStyle } from 'styled-components';

export const InfoWindowStyles = createGlobalStyle`
  .gm-style {
    .gm-style-iw-c {
      padding: 0;
    }
    .gm-style-iw-tc {
      display: none;
    }
    button.gm-ui-hover-effect {
      display: none !important;
    } 
    .gm-style-iw-d {
      overflow: hidden !important;
    }
  }
  .cluster {
    background-color: ${({ theme }) => theme.colors.r60};
    border-radius: 50px;
    & > div {
        color: ${({ theme }) => theme.colors.white} !important;
    }
    img {
        display: none;
    }
  }
`;
